module.exports = __webpack_public_path__ + "img/male_B_03.e9bf7f8a.png";